import styled from 'styled-components'
import { Space } from 'antd'

export const StyledDHSCheckEligibilityContainer = styled.div`
  display: inline-block;
`

export const StyledEligibilityBadge = styled(Space)`
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
`

export const StyledDHSCheckEligibilityLoadingContainer = styled.div`
  padding: 24px;
  background: #fff;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`
